import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { QuickSummaryProps } from '../src/QuickSummaryStreaming/QuickSummaryStreamingEntryPoint.tsx';

export const QuickSummaryStreamingComponent: LoadableType<QuickSummaryProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-QuickSummaryStreamingComponent" */ '../src/QuickSummaryStreaming/QuickSummaryStreamingEntryPoint.tsx'
			)
		).QuickSummaryStreamingEntryPoint,
});
